__turbopack_context__.v({
  "carousel-dots": "carousel-dots-component-module-scss-module__tYZrcG__carousel-dots",
  "carousel-dots__navigation-dot": "carousel-dots-component-module-scss-module__tYZrcG__carousel-dots__navigation-dot",
  "carousel-dots__navigation-dot--button": "carousel-dots-component-module-scss-module__tYZrcG__carousel-dots__navigation-dot--button",
  "carousel-dots__navigation-dot--loading": "carousel-dots-component-module-scss-module__tYZrcG__carousel-dots__navigation-dot--loading",
  "carousel-dots__navigation-dot--selected": "carousel-dots-component-module-scss-module__tYZrcG__carousel-dots__navigation-dot--selected",
  "loading": "carousel-dots-component-module-scss-module__tYZrcG__loading",
});
